import { render, staticRenderFns } from "./AdminJurisdictionForm.vue?vue&type=template&id=10b8b17b&"
import script from "./AdminJurisdictionForm.vue?vue&type=script&lang=js&"
export * from "./AdminJurisdictionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports